import {
  TimeInput as NextUITimeInput,
  TimeInputProps as NextUITimeInputProps,
} from "@heroui/react";
import { Time } from "@internationalized/date";
import { getDateInputClassNames } from "ds/utils/styles";
import { toTime } from "../../utils/date";

type Color = Extract<NextUITimeInputProps["color"], "default">;
type LabelPlacement = Extract<
  NextUITimeInputProps["labelPlacement"],
  "outside"
>;
type Variant = Extract<NextUITimeInputProps["variant"], "bordered">;

export type TimeInputProps = Omit<
  NextUITimeInputProps,
  "color" | "labelPlacement" | "variant" | "value" | "minValue" | "maxValue"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  maxValue?: Date;
  minValue?: Date;
  value?: Date | Time | null;
  variant?: Variant;
};

export function TimeInput(props: TimeInputProps) {
  const { maxValue, minValue, ref, value, ...rest } = props;

  return (
    <NextUITimeInput
      ref={ref}
      {...rest}
      classNames={getDateInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement="outside"
      maxValue={toTime(maxValue) as NextUITimeInputProps["maxValue"]}
      minValue={toTime(minValue) as NextUITimeInputProps["minValue"]}
      value={toTime(value) as NextUITimeInputProps["value"]}
      variant="bordered"
    />
  );
}

TimeInput.displayName = "RecareUI.TimeInput";
